import React, {FC} from 'react'

type EmptySectionProps = {
  height?: number | string
}

export const EmptySection: FC<EmptySectionProps> = ({height = "100vh"}) => {
  return (
      <div className={"d-flex align-items-center justify-content-center"} style={{
        height: height
      }}>
        <div className={"text-center"}>
          <i className={"fas fa-folder-open fs-3x"}></i>
          <h3 className={"text-center mt-3"}>Ma'lumotlar topilmadi</h3>
        </div>
      </div>
  )
}
